import Container from "@/components/ui/Container";
import SectionLabel from "@/components/ui/SectionLabel";
import GradientHeading from "@/components/ui/GradientHeading";
import Card from "@/components/ui/Card";

const outcomes = [
  {
    title:
      "Уязвимости перестают накапливаться в отчётах и становятся задачами, с которыми можно работать",
  },
  {
    title: "Появляется понятный порядок исправлений",
    desc: "Не нужно разбирать весь список CVE и вручную сопоставлять уязвимости с кодом",
  },
  {
    title: "Решения принимаются быстрее",
    desc: "Приоритет строится на реальном риске, а не на формальных оценках",
  },
  {
    title: "Система подсказывает конкретные действия",
    desc: "Что изменить с учётом архитектуры и сценария использования, чтобы снизить риск",
  },
];

export default function TeamChangeSection() {
  return (
    <section>
      <Container>
        <div className="xl:grid xl:grid-cols-4 xl:gap-5">
          <SectionLabel>Как меняется подход</SectionLabel>
          <div className="mt-3 xl:col-span-3 xl:mt-0">
            <GradientHeading className="xl:tracking-[-1.2px]">
              Что меняется для команды
            </GradientHeading>
          </div>
        </div>

        <div className="relative mt-[60px] grid grid-cols-1 gap-2.5 min-[478px]:gap-5 md:grid-cols-2 xl:mt-[90px] xl:grid-cols-4">
          {/* mobile connector line */}
          <span
            aria-hidden
            className="pointer-events-none absolute inset-y-0 left-1/2 w-1 -translate-x-1/2 bg-surface md:hidden"
          />

          {/* desktop connector line */}
          <span
            aria-hidden
            className="pointer-events-none absolute inset-x-0 top-1/2 hidden h-1 -translate-y-1/2 bg-surface xl:block"
          />

          {outcomes.map(({ title, desc }) => (
            <Card key={title} className="xl:min-h-[216px] xl:justify-between">
              <h3 className="text-[21px] font-bold leading-tight tracking-[-0.21px] text-navy">
                {title}
              </h3>

              {desc && (
                <p className="mt-6 text-[16px] font-medium leading-[1.3] text-ink xl:mt-0">
                  {desc}
                </p>
              )}
            </Card>
          ))}
        </div>
      </Container>
    </section>
  );
}
